import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';
import { boolean, round } from 'mathjs';

import moStore, { toggleValue } from '@store/index';
import EffectService from '@service/effect';
import { newRate } from '@tool/index';

const moSettleCompare = observable({
  type: 'chart', // chart, table
  empty: false,
  timeList: <number[]>[],
  timeActive: <number | string>'',
  tableTitle: <any[]>[],
  tableList: <any[]>[],
  leftXData: <any[]>[],
  leftYData: <any[]>[],
  rightXData: <any[]>[],
  rightYData: <any[]>[],
  desc: <any[]>[],
  overview: <any[]>[],
});

const filterValue = (value: any) => {
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  return `${Number(value).toLocaleString()}人`;
};

const settleCompareInit = action(async (res: any) => {
  if (isEmpty(res) || isEmpty(res.data)) {
    moSettleCompare.empty = true;
    return;
  }
  moSettleCompare.empty = false;
  const leftXArr: any[] = [];
  const leftYArr: any[] = [];
  const rightXArr: any[] = [];
  const rightYArr: any[] = [];
  const tableArr: any[] = [];

  res.data.map((item: any) => {
    leftXArr.unshift(item.value);
    leftYArr.unshift(item.industry);
    rightXArr.unshift(item.ratio);
    rightYArr.unshift(item.industry);
  });
  res.data.map((item: any) => {
    const tempArr: any[] = [];
    for (const key in item) {
      if (key === 'ratio') tempArr.push(newRate(item[key]));
      else if (key === 'value') tempArr.push(filterValue(item[key]));
      else tempArr.push(item[key]);
    }
    tableArr.push(tempArr);
  });

  runInAction(() => {
    moSettleCompare.leftXData = leftXArr;
    moSettleCompare.leftYData = leftYArr;
    moSettleCompare.rightXData = rightXArr;
    moSettleCompare.rightYData = rightYArr;
    moSettleCompare.overview = res.overview;
    moSettleCompare.tableTitle = ['行业', '人员规模', '变化率'];
    moSettleCompare.tableList = tableArr;
  });
});

const changeType = action((value: string) => {
  moSettleCompare.type = value;
  localStorage.setItem('settleIndustryType', value);
});

const timeTabChange = action(async (value: number | string, change?:boolean) => {
  runInAction(() => {
    moSettleCompare.timeActive = value;
  });
  localStorage.setItem('settleIndustryYear', value.toString());
  if (change) return;
  toggleValue('isLoading', true);
  setTimeout(() => {
    toggleValue('isLoading', false);
  }, 10000);
  const res: any = await EffectService.settleMultiIndustry({ year: moSettleCompare.timeActive });
  if (isEmpty(res) || isEmpty(res.data)) {
    toggleValue('isLoading', false);
  }
  settleCompareInit(res);
  toggleValue('isLoading', false);
});

export default moSettleCompare;
export {
  settleCompareInit, changeType, timeTabChange,
};
